<template>
  <div class="p-4">
    <!-- Order Food -->
    <router-link
      class="relative block rounded-xl overflow-hidden"
      to="/management/analytics"
    >
      <div
        class="transition-all transform"
        @touchstart="toggleAnimation($event)"
        @touchend="toggleAnimation"
      >
        <img src="../../assets/img/banner_analytics.png" class="w-full" />
      </div>
      <div
        class="absolute w-full h-full top-0 bg-black/80"
        v-if="userRole !== 'Admin'"
        @click.prevent
      ></div>
    </router-link>

    <div class="flex justify-between gap-4 mt-4">
      <!-- Menu -->
      <router-link
        class="relative block rounded-xl overflow-hidden"
        to="/management/users"
      >
        <div
          class="transition-all transform"
          @touchstart="toggleAnimation($event)"
          @touchend="toggleAnimation"
        >
          <img src="../../assets/img/banner_users.png" />
        </div>
        <div
          class="absolute w-full h-full top-0 bg-black/80"
          v-if="userRole !== 'Admin'"
          @click.prevent
        ></div>
      </router-link>

      <!-- Factors -->
      <a
        class="relative block rounded-xl overflow-hidden"
        href="#"
        @click.prevent="messageModal = true"
      >
        <div
          class="transition-all transform"
          @touchstart="toggleAnimation($event)"
          @touchend="toggleAnimation"
        >
          <img src="../../assets/img/banner_send_message.png" />
        </div>
        <div
          class="absolute w-full h-full top-0 bg-black/80"
          v-if="userRole !== 'Admin'"
          @click.prevent
        ></div>
      </a>
    </div>

    <router-link
      class="relative block rounded-xl overflow-hidden"
      to="/management/hotel-analytics"
    >
      <div
        class="transition-all transform"
        @touchstart="toggleAnimation($event)"
        @touchend="toggleAnimation"
      >
        <img src="../../assets/img/banner_hotel_analytics.png" class="w-full" />
      </div>
      <div
        class="absolute w-full h-full top-0 bg-black/80"
        v-if="userRole !== 'Admin' && userRole !== 'Hotel'"
        @click.prevent
      ></div>
    </router-link>
    <router-link
      class="relative block rounded-xl overflow-hidden"
      to="/management/OptionPage"
    >
      <div
        class="transition-all transform"
        @touchstart="toggleAnimation($event)"
        @touchend="toggleAnimation"
      >
        <img src="../../assets/img/setting.png" class="w-full" />
      </div>
      <div
        class="absolute w-full h-full top-0 bg-black/80"
        v-if="userRole !== 'Admin' && userRole !== 'Hotel'"
        @click.prevent
      ></div>
    </router-link>
    <router-link
      class="relative block rounded-xl overflow-hidden"
      to="/UploadBanner"
    >
      <div
        class="transition-all transform"
        @touchstart="toggleAnimation($event)"
        @touchend="toggleAnimation"
      >
        <img src="../../assets/img/upload.png" class="w-full" />
      </div>
      <div
        class="absolute w-full h-full top-0 bg-black/80"
        v-if="userRole !== 'Admin' && userRole !== 'Hotel'"
        @click.prevent
      ></div>
    </router-link>
    <!-- <router-link
      class="relative block rounded-xl overflow-hidden"
      to="/management/ReportSuggest"
    >
      <div
        class="transition-all transform"
        @touchstart="toggleAnimation($event)"
        @touchend="toggleAnimation"
      >
        <img src="../../assets/img/banner_hotel_analytics.png" class="w-full" />
      </div>
      <div
        class="absolute w-full h-full top-0 bg-black/80"
        v-if="userRole !== 'Admin' && userRole !== 'Hotel'"
        @click.prevent
      ></div>
    </router-link> -->
  </div>

  <!--  Message Modal -->
  <transition name="fade">
    <div
      class="flex justify-center items-center fixed top-0 bg-gray-500/60 h-full w-full left-0 right-0 z-20"
      v-if="messageModal"
      @click="messageModal = !messageModal"
    >
      <div class="bg-gray-800 rounded-lg w-3/4 p-4" @click.stop>
        <h1 class="text-center text-white">ارسال پیام</h1>
        <form action="" class="mt-4" @submit.prevent="sendMessage">
          <Input type="text" placeholder="پیام..." v-model="message" required />

          <select class="w-full mt-4 rounded-xl p-2" v-model="messageTarget">
            <option value="">همه</option>
            <option
              v-for="user in users"
              :key="user.username"
              :value="user.username"
            >
              {{ user.fullName }}
            </option>
          </select>
          <Button class="mt-4">ارسال پیام گروهی</Button>
        </form>
      </div>
    </div>
  </transition>
</template>

<script>
import { getUsersList, sendNotification } from "../../API/API";
import Input from "../../components/Input";
import Button from "../../components/General/Button";

export default {
  name: "Index",
  components: { Button, Input },
  data() {
    return {
      messages: [],
      messageModal: false,
      message: "",
      messageTarget: "",
      users: [],
    };
  },
  async created() {
    this.users = (await getUsersList()).data.result;
    this.users = this.users.filter((user) => user.enable);
  },
  methods: {
    toggleAnimation(event) {
      event.currentTarget.classList.toggle("scale-95");
      event.currentTarget.classList.toggle("shadow");
    },
    sendMessage() {
      //Replace Persian Digits with English Digits
      sendNotification(
        "پیغام مدیریت",
        this.message.replace(/[۰-۹]/g, (value) => "۰۱۲۳۴۵۶۷۸۹".indexOf(value)),
        this.messageTarget
      ).then((resp) => {
        this.messageModal = false;
        this.message = "";
        this.$swal({
          icon: "success",
          title: "موفق",
          text: resp.data.result,
          confirmButtonColor: "#fcd34d",
          confirmButtonText: "باشه",
        });
      });
    },
  },
  computed: {
    userRole() {
      return this.$store.state.user.role;
    },
  },
};
</script>

<style scoped></style>
